"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Simple class for persisting achievement state.
 */
class KHAchievements {
    constructor() {
        this.achievementMap = new Map();
    }
    toJSON() {
        return Object.fromEntries(this.achievementMap);
    }
    fromJSON(json) {
        for (const [key, value] of Object.entries(json)) {
            if (typeof value === 'boolean' && value) {
                this.achievementMap.set(key, value);
            }
            else {
                console.log(`Unexpected value in achievement map for key ${key}`, value);
            }
        }
    }
    setManager(manager) {
        this.manager = manager;
    }
    /**
     * Unlocks achievement and returns whether or not the achievement has
     * already been unlocked. Also saves unless the save parameter is false or
     * the achievement has already been unlocked.
     */
    unlock(key, save = true) {
        if (this.achievementMap.has(key) && this.achievementMap.get(key)) {
            return false;
        }
        console.log(`Unlocked ${key}`);
        this.achievementMap.set(key, true);
        this.dirty = true;
        if (save)
            this.save();
    }
    lock(key, save = true) {
        if (this.achievementMap.delete(key)) {
            this.dirty = true;
            if (save)
                this.save();
        }
    }
    save() {
        if (this.dirty) {
            this.manager.save(this);
            this.dirty = false;
        }
    }
}
KHAchievements.MENAGERIE_KEY = 'kh.menagerie.achievements';
exports.default = KHAchievements;
